<template>
  <div class="demo-modal">
    <div class="demo-modal-group">
      <div class="demo-title">Toast</div>
      <div class="bx-panel">
        <div class="bx-panel-body">
          <div class="bx-list">
            <div class="bx-list-item" @click="toast('最长文案不超过28个字符')">
              <div class="bx-list-item-title">轻提示</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
            <div class="bx-list-item" @click="toast('成功提示','success')">
              <div class="bx-list-item-title">成功提示</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
            <div class="bx-list-item" @click="toast('失败提示','error')">
              <div class="bx-list-item-title">失败提示</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
            <div class="bx-list-item" @click="toast('警示提示','warn')">
              <div class="bx-list-item-title">警示提示</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="demo-modal-group">
      <div class="demo-title">Modal</div>
      <div class="bx-panel">
        <div class="bx-panel-body">
          <div class="bx-list">
            <div class="bx-list-item" @click="modal()">
              <div class="bx-list-item-title">通用Modal</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="demo-modal-group">
      <div class="demo-title">Alert</div>
      <div class="bx-panel">
        <div class="bx-panel-body">
          <div class="bx-list">
            <div class="bx-list-item" @click="alert('普通Alert')">
              <div class="bx-list-item-title">普通Alert</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
            <div class="bx-list-item" @click="alert('带标题Alert','标题')">
              <div class="bx-list-item-title">带标题Alert</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
            <div class="bx-list-item" @click="alert('<div style=\'color:red\'>自定义内容</div>')">
              <div class="bx-list-item-title">自定义内容Alert</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="demo-modal-group">
      <div class="demo-title">Dialog</div>
      <div class="bx-panel">
        <div class="bx-panel-body">
          <div class="bx-list">
            <div class="bx-list-item" @click="dialog('普通Dialog')">
              <div class="bx-list-item-title">普通Dialog</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
            <div class="bx-list-item" @click="dialog('带标题Dialog','标题')">
              <div class="bx-list-item-title">带标题Dialog</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
            <div class="bx-list-item" @click="dialog('<div style=\'color:red\'>自定义内容</div>')">
              <div class="bx-list-item-title">自定义内容Dialog</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="demo-modal-group">
      <div class="demo-title">Picker</div>
      <div class="bx-panel">
        <div class="bx-panel-body">
          <div class="bx-list">
            <div class="bx-list-item" @click="picker()">
              <div class="bx-list-item-title">通用Picker(仅有布局,未有动效)</div>
              <div class="bx-list-item-link"><i class="bx-icon"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bx-alert" v-if="alertVisible">
      <div class="bx-modal-overlay"></div>
      <div class="bx-modal">
        <div class="bx-modal-header" v-if="alertTitle">
          <div class="bx-modal-title">{{alertTitle}}</div>
        </div>
        <div class="bx-modal-body">
          <div class="bx-modal-inner">
            <div class="bx-modal-content" v-html="alertMsg"></div>
          </div>
        </div>
        <div class="bx-modal-footer">
          <div class="bx-modal-buttons">
            <a class="bx-modal-btn bx-modal-link" @click="closeModal()">知道了</a>
          </div>
        </div>
      </div>
    </div>

    <div class="bx-dialog" v-if="dialogVisible">
      <div class="bx-modal-overlay"></div>
      <div class="bx-modal">
        <div class="bx-modal-header" v-if="dialogTitle">
          <div class="bx-modal-title">{{dialogTitle}}</div>
        </div>
        <div class="bx-modal-body">
          <div class="bx-modal-inner">
            <div class="bx-modal-content" v-html="dialogMsg"></div>
          </div>
        </div>
        <div class="bx-modal-footer">
          <div class="bx-modal-buttons">
            <a class="bx-modal-btn" @click="closeModal()">取消</a>
            <a class="bx-modal-btn bx-modal-link" @click="closeModal()">确定</a>
          </div>
        </div>
      </div>
    </div>

    <div class="bx-modal-panel" v-if="modalVisible">
      <div class="bx-modal-overlay"></div>
      <div class="bx-modal">
        <div class="bx-modal-header">
          <div class="bx-modal-close" @click="closeModal()"><i class="bx-icon"></i></div>
          <div class="bx-modal-title">温馨提示</div>
        </div>
        <div class="bx-modal-body">
          <div class="bx-modal-inner">
            <div class="bx-modal-title">标题</div>
            <div class="bx-modal-content">补充说明正文</div>
          </div>
        </div>
        <div class="bx-modal-footer">
          <div class="bx-modal-buttons">
            <a class="bx-modal-btn" @click="closeModal()">取消</a>
            <a class="bx-modal-btn bx-modal-link" @click="closeModal()">确定</a>
          </div>
        </div>
      </div>
    </div>

    <div class="bx-toast" :class="toastType" v-if="toastVisible">
      <i class="bx-icon" v-if="toastType"></i>{{toastMsg}}
    </div>

    <div class="bx-picker-panel" v-if="pickerVisible">
      <div class="bx-picker-overlay" @click="closeModal()"></div>
      <div class="bx-picker">
        <div class="bx-picker-header">
          <a class="bx-picker-action bx-picker-close" @click="closeModal()">关闭</a>
          <a class="bx-picker-action bx-picker-confirm" @click="closeModal()">确定</a>
        </div>
        <div class="bx-picker-body">
          <div class="bx-picker-group">
            <div class="bx-picker-group-mask"></div>
            <div class="bx-picker-indicator"></div>
            <div class="bx-picker-content">
              <div class="bx-picker-item">浙江省</div>
              <div class="bx-picker-item">福建省</div>
              <div class="bx-picker-item">江苏省</div>
              <div class="bx-picker-item">广东省</div>
              <div class="bx-picker-item">山东省</div>
              <div class="bx-picker-item">安徽省</div>
              <div class="bx-picker-item">陕西省</div>
              <div class="bx-picker-item">河南省</div>
              <div class="bx-picker-item">河北省</div>
            </div>
          </div>
          <div class="bx-picker-group">
            <div class="bx-picker-group-mask"></div>
            <div class="bx-picker-indicator"></div>
            <div class="bx-picker-content">
              <div class="bx-picker-item">杭州市</div>
              <div class="bx-picker-item">绍兴市</div>
              <div class="bx-picker-item">温州市</div>
              <div class="bx-picker-item">宁波市</div>
              <div class="bx-picker-item">丽水市</div>
              <div class="bx-picker-item">温岭市</div>
              <div class="bx-picker-item">嘉兴市</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        toastMsg: '',
        toastVisible: false,
        toastType: null,
        alertVisible: false,
        alertMsg: '',
        alertTitle: '',
        dialogVisible: false,
        dialogMsg: '',
        dialogTitle: '',
        modalVisible: false,
        pickerVisible: false
      }
    },
    methods: {
      toast: function (msg, type) {
        var self = this;
        self.toastMsg = msg;
        self.toastVisible = true;
        type && (self.toastType = 'bx-toast--' + type);
        window.setTimeout(function () {
          self.toastMsg = '';
          self.toastVisible = false;
          self.toastType = null;
        }, 2000);
      },
      alert: function (msg, title) {
        var self = this;
        self.alertMsg = msg;
        self.alertVisible = true;
        self.alertTitle = title;
      },
      dialog: function (msg, title) {
        var self = this;
        self.dialogMsg = msg;
        self.dialogVisible = true;
        self.dialogTitle = title;
      },
      modal: function () {
        var self = this;
        self.modalVisible = true;
      },
      picker: function () {
        var self = this;
        self.pickerVisible = true;
      },
      closeModal: function () {
        var self = this;
        self.alertVisible && (self.alertVisible = false);
        self.dialogVisible && (self.dialogVisible = false);
        self.modalVisible && (self.modalVisible = false);
        self.pickerVisible && (self.pickerVisible = false);
      }
    }
  }
</script>
<style>
  .demo-modal {
    padding-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/ui/Modal.vue